export const theme = {
    FontFamily: '"ProximaNova", "Helvetica Neue", Helvetica, Arial, sans-serif',
    Container: {
        tablet: '768px',
        main: '1024px',
    },
    Colors: {
        white: '#ffffff',
        mainColor: '#66cccc',
        mainDarkenColor: '#40aeae',
        greyLight: '#bbbbbb',
        black: '#000000',
        success: '#27AE60',
        alert: '#EB5757',
        darkBg: '#0F1821',
        greyText: '#aaaaaa',
        primary: {
            black: {
                black: '#0F1821',
            },
        },
    },
    Media: {
        whenMobileLandscape: '@media (min-width: 500px)',
        whenTablet: '@media (min-width: 800px)',
        whenDesktop: '@media (min-width: 1024px)',
        whenDesktopXL: '@media (min-width: 1280px)',
    },
};
